import React, { useEffect, useState, useRef } from "react";
import { Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { supabase } from "../supabaseClient";

const PlacesCategoryList = ({ selectedCategoryId, isAdmin }) => {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();
  const buttonRefs = useRef({}); 

  useEffect(() => {
    const fetchCategories = async () => {
      const { data, error } = await supabase
        .from("places_category")
        .select("*")
        .order("num", { ascending: true });

      if (error) {
        console.error("카테고리 불러오기 실패:", error.message);
        return;
      }

      // "전체" 카테고리 추가
      setCategories([{ id: "all", title: "전체" }, ...data]);
    };

    fetchCategories();
  }, []);


  useEffect(() => {
    // 선택된 버튼을 스크롤해서 보여줌
    const selectedRef = buttonRefs.current[selectedCategoryId];
    if (selectedRef && selectedRef.scrollIntoView) {
      selectedRef.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
    }
  }, [selectedCategoryId, categories]);


  const handleCategoryClick = (id) => {
    isAdmin ? navigate(`/places?category_id=${id}`) : navigate(`/find?category_id=${id}`);
  };

  return (
    <Box sx={{
        display: "flex",
        overflowX: "auto",
        gap:0.5,
        scrollbarWidth: "none", // Firefox
        "&::-webkit-scrollbar": { display: "none" }, // Chrome
        pt: 1,
        pb :1,
    }}>
      {categories.map((category) => (
        <Button
          key={category.id}
          ref={(el) => (buttonRefs.current[category.id] = el)}
          variant={String(category.id) === String(selectedCategoryId) ? "contained" : "outlined"}
          onClick={() => handleCategoryClick(category.id)}
          sx={{ 
            whiteSpace: "nowrap",
            fontSize: "0.9em",
            borderRadius: 4,
            flexShrink: 0, // ✅ 줄바꿈 없이 유지
          }}>
          {category.title}
        </Button>
      ))}
    </Box>
  );
};

export default PlacesCategoryList;
